import React from 'react';
import IProdukt from '../../interfaces/IProdukt';
import { filterToLabel } from '../../utils/FilterHelper';

type Props = {
    filterType: string;
    product: IProdukt;
    value: any;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { product, filterType, value, onChange } = props;
    const filterName = filterType.charAt(0).toUpperCase() + filterType.slice(1);

    let filter;
    for (const f of product.filters) {
        if (f.typ === filterType) {
            filter = f;
        }
    }

    const werte = filter.wert.split("|");
    let defaultValue = value;

    React.useEffect(() => {
        let found = false;
        
        for (const wert of werte) {
            if (wert === value) {
                found = true;
            }
        }
        if (!found) {
            defaultValue = werte[0]
            onChange(defaultValue );
        }
    }, [product.filters]);
    


    const onSelect = (e) => {
        onChange(e.currentTarget.value);
    }

    return <div className="field  is-horizontal">
        <div className="field-label is-normal">
            <label className="label">{filterToLabel(filterName)}</label>
        </div>
        <div className="field-body">
            <div className="field">
                <div className="control">
                    <div className="select is-fullwidth">
                    <select name={filterName} onChange={onSelect} value={defaultValue }>
                        {werte.map((option, optionKey) => {
                            return <option key={optionKey} value={option} >{option}</option>
                        })}
                    </select>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}